import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ItemTipoMultiselectComponent } from './item-tipo-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ItemTipoMultiselectComponent
    ],
    exports: [
        ItemTipoMultiselectComponent
    ]
})
export class ItemTipoMultiselectModule { }
